<template>
  <div class="p-6">
    <!-- 页面标题和操作按钮 -->
    <div class="flex justify-between items-center mb-6">
      <div>
        <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">佣金策略管理</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">管理推广返利佣金策略和层级费率</p>
      </div>
      <button @click="handleCreate"
        class="primary-btn flex items-center gap-2">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
        </svg>
        创建策略
      </button>
    </div>

    <!-- 策略列表 -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow dark:shadow-gray-900">
      <PolicyList :policies="policies" @edit="handleEdit" />
    </div>

    <!-- 创建/编辑策略 Modal -->
    <Modal :show="showModal" @close="closeModal" :title="isEdit ? '编辑策略' : '创建策略'" size="large">
      <PolicyForm
        :policy="currentPolicy"
        :is-edit="isEdit"
        @submit="handleSubmit"
        @cancel="closeModal"
      />
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import Modal from '@/components/common/Modal.vue'
import PolicyList from './components/PolicyList.vue'
import PolicyForm from './components/PolicyForm.vue'
import { getPoliciesAPI, createPolicyAPI, updatePolicyAPI } from '@/api/referral/policy'
import type { CommissionPolicy, PolicyCreateRequest } from '@/types/referral/policy'
import toaster from '@/utils/toaster'

/** 策略列表 */
const policies = ref<CommissionPolicy[]>([])

/** 当前操作的策略 */
const currentPolicy = ref<CommissionPolicy | undefined>(undefined)

/** Modal 状态 */
const showModal = ref(false)
const isEdit = ref(false)

/** 加载策略列表 */
const loadPolicies = async () => {
  try {
    const res = await getPoliciesAPI()
    if (res.status === 200 && res.data) {
      policies.value = Array.isArray(res.data) ? res.data : []
    }
  } catch (error) {
    console.error('加载策略失败:', error)
  }
}

/** 创建策略 */
const handleCreate = () => {
  currentPolicy.value = undefined
  isEdit.value = false
  showModal.value = true
}

/** 编辑策略 */
const handleEdit = (policy: CommissionPolicy) => {
  currentPolicy.value = policy
  isEdit.value = true
  showModal.value = true
}

/** 提交表单 */
const handleSubmit = async (data: PolicyCreateRequest) => {
  try {
    if (isEdit.value && currentPolicy.value) {
      await updatePolicyAPI(currentPolicy.value.id, data)
      toaster.success('策略更新成功')
    } else {
      await createPolicyAPI(data)
      toaster.success('策略创建成功')
    }
    await loadPolicies()
    closeModal()
  } catch (error: any) {
    toaster.error(error.message || '保存策略失败')
  }
}

/** 关闭 Modal */
const closeModal = () => {
  showModal.value = false
  currentPolicy.value = undefined
}

onMounted(() => {
  loadPolicies()
})
</script>
